import { isCreateMemberResponse, } from '@urbanik/api-contracts';
export class CreateMemberApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
        this.name = 'CreateMemberApiError';
    }
}
export async function createMember(baseUrl, input) {
    let response;
    try {
        response = await fetch(`${baseUrl.replace(/\/$/, '')}/identity/members`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify(input),
        });
    }
    catch {
        throw new CreateMemberApiError('unavailable', 'No pudimos conectar con el servidor.');
    }
    let payload;
    try {
        payload = await response.json();
    }
    catch {
        throw new CreateMemberApiError('invalid', 'El servidor devolvió una respuesta inválida.');
    }
    const message = typeof payload === 'object' &&
        payload !== null &&
        typeof payload.message === 'string'
        ? payload.message
        : 'No pudimos registrar al socio.';
    if (response.status === 400)
        throw new CreateMemberApiError('validation', message);
    if (response.status === 401)
        throw new CreateMemberApiError('unauthorized', message);
    if (response.status === 403)
        throw new CreateMemberApiError('forbidden', message);
    if (response.status === 409)
        throw new CreateMemberApiError('duplicate', message);
    if (!response.ok)
        throw new CreateMemberApiError('unavailable', message);
    if (!isCreateMemberResponse(payload))
        throw new CreateMemberApiError('invalid', 'El contrato de alta no es válido.');
    return payload;
}
